import { render, staticRenderFns } from "./invoiceCategories.vue?vue&type=template&id=981c8f78"
import script from "./invoiceCategories.vue?vue&type=script&lang=js"
export * from "./invoiceCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports